import {
  APP_CODE,
  HttpService,
  ProfilesProvider,
  ProfilesService,
} from "@sportal/api";

export const makeProfilesService = (
  http: HttpService,
  baseUrl: string
): ProfilesService =>
  new ProfilesService(new ProfilesProvider(http, baseUrl, APP_CODE.SB));
